import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink} from "@angular/router";
import {InputComponent} from "../../../shared-module/components/input/input.component";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {AuthService} from "../../../shared-module/services/auth.service";
import ModalService from "../../../shared-module/services/modal.service";
import {
  PasswordResetConfirmModalComponent
} from "../../components/password-reset-confirm-modal/password-reset-confirm-modal.component";
import {FormChangeListenerService} from "../../../shared-module/services/form-change-listener.service";

@Component({
    selector: 'app-password-forgotten',
    imports: [
        RouterLink,
        InputComponent,
        ButtonComponent,
        ReactiveFormsModule,
    ],
    templateUrl: './password-forgotten.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './password-forgotten.component.scss'
})
export class PasswordForgottenComponent {
  private readonly authService: AuthService = inject(AuthService);
  private readonly modalService: ModalService = inject(ModalService);
  private readonly formChangeListenerService: FormChangeListenerService = inject(FormChangeListenerService);

  protected readonly screen: Screen = screen;

  public form: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email])
  });

  constructor() {
    this.formChangeListenerService.initializeFormListener(this.form);
  }

  public submit(): void {
    if (this.form.invalid) {
      return;
    }

    this.authService.reset(this.form.controls['email'].value as string).subscribe((isResetted: boolean) => {
      this.modalService.open(
        PasswordResetConfirmModalComponent,
        {
          isResetted: isResetted,
        },
        {
          title: 'Wachtwoord vergeten',
          showCloseButton: true,
          width: '550px',
        }
      );
    });
  }
}
